module.exports = __webpack_public_path__ + "static/media/js.73b561ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/js.png
// module id = 744
// module chunks = 0